export class Card {
  specialityName: string;
  specialityCode: string;
  inProgressCount: number;
  needsReviewCount: number;
  completedCount: number;
}
